// Formula component for tag creation step
import type { SoftTagState } from '../utils/types';
import FormulaInput from './FormulaInput';
import { FormulaMateBuildFormulaScope } from '../../formulaMate/FormulaMateContext';

// Props for Formula component
// handleConfirm: callback for confirming formula step
// handleBack: callback for going back to previous step
type FormulaProps = {
  handleConfirm: (values: any) => void;
  handleBack: () => void;
  softTagDetails: SoftTagState | null;
  isEditMode: boolean;
};

// Renders formula step UI with navigation buttons
export const Formula = ({
  handleConfirm,
  handleBack,
  softTagDetails,
  isEditMode,
}: FormulaProps) => {
  return (
    <div className="w-[95%] m-auto">
      <FormulaMateBuildFormulaScope />
      {/* Formula input or content goes here */}
      <FormulaInput
        handleConfirm={handleConfirm}
        handleBack={handleBack}
        softTagDetails={softTagDetails}
        isEditMode={isEditMode}
      />
    </div>
  );
};
